export default {
  users_analysis: {
    days_30: '近30日',
    index: {
      summary: {
        total_users_count: '总人数(人)',
        total_top_ups_count: '充值(人)',
        total_charge_count: '充电(人)',
        active_count: '30日内活跃(人)'
      },
      today: {
        title: '今日新增',
        today_users_count: '今日注册(人)',
        yesterday_users_count: '昨日注册(人)',
        today_charge_users_count: '新增充电(人)'
      },
      column_chart: {
        title: '新增用户',
        to_more: '近30日新增用户'
      },
      area_chart: {
        title: '充电用户数',
        to_more: '近30日充电用户'
      },
      line_chart: {
        title: '充值用户数',
        to_more: '近30日充值用户'
      },
      conversion: {
        info: '活跃指标以充值和充电为主',
        label: '新用户转化',
        top_up_users_count: '人数(人)',
        rate: '转化率',
        total_top_ups_amount: '金额(元)',
        top_up: {
          title: '充值'
        },
        charge: {
          order: '订单'
        }
      }
    }
  }
}
